namespace HA.Core.Entity {
    export class Entity extends HA.HAObject {

        /**
         *
         * @returns {string}
         */
        public static  genId() {
            return "ID" + Entity.getUUId();
        }

        public static getUUId() {
            return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
                const r = Math.random() * 16 | 0, v = c === "x" ? r : ( r & 0x3 | 0x8 );
                return v.toString(16);
            });
        }

        /**
         *
         * @returns {any}
         */
        public setId(id: any) {
            return this.addToData("id", id);
        }

        /**
         *
         * @returns {any}
         */
        public getId() {
            return this.get("id") || this.get("_id");
        }

        /**
         *
         * @param data
         */
        protected initialize(data?: any) {
            super.initialize(data);
            if (!this.getId()) {
                this.setId(Entity.genId());
            }
        }

    }
}
